import React, { useState } from 'react';
import { Table, Button, Tooltip, Avatar, Modal, Spin, Tag, Typography, Empty, Popover, Row, Col, message, Flex, Divider } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, CloudDownloadOutlined, EditOutlined, FileOutlined, InfoCircleOutlined, } from '@ant-design/icons';
import { useMediaQuery } from 'react-responsive';
import usePermissions from '../hooks/usePermissions';
import moment from 'moment';
import { catchError } from '../utils/errorHandler';
import axiosInstance from '../services/axiosInstance';
const { Title, Paragraph } = Typography;

const MobileNewUpdates = ({ data, loading, onViewDescription, showPublishModal }) => {

    const { hasPermission } = usePermissions();
    const columns = [
        {
            title: 'Field',
            dataIndex: 'field',
            key: 'field',
            width: '40%',
            render: (text) => <div strong>{text}</div>,
        },
        {
            title: 'Value',
            dataIndex: 'value',
            key: 'value',
            width: '60%',
        },
    ];

    const generateTableData = (item) => [
        { key: '1', field: 'Title', value: item.title },
        ...hasPermission("can_view_group_permission_column_in_new_update") ? [{
            key: '2',
            field: 'Published',
            value: item.is_published ? 'Yes' : 'No',
        }] : [],
        {
            key: '3',
            field: 'Published On',
            value: moment(item.published_on).local().format("DD-MM-YYYY hh:mm A"),
        },
        {
            key: '3',
            field: 'Description',
            value: (
                <span
                    style={{ color: '#1677ff', cursor: 'pointer' }}
                    onClick={() => onViewDescription(item.description, item.files)}
                >
                    View Description
                </span>
            ),
        },
        ...hasPermission("can_view_group_permission_column_in_new_update") ? [{
            key: '5',
            field: 'Group Permission',
            value: Array.isArray(item.group_permissions) && item.group_permissions.length > 0 ? (
                <Avatar.Group>
                    {item.group_permissions.slice(0, 3).map((group, idx) => (
                        <Tooltip key={idx} title={group}>
                            <Avatar style={{ backgroundColor: 'green', color: '#fff' }}>
                                {group.split(' ').map(w => w[0]).join('').toUpperCase()}
                            </Avatar>
                        </Tooltip>
                    ))}

                    {item.group_permissions.length > 3 && (
                        <Popover
                            content={
                                <div style={{ maxWidth: 200, maxHeight: "200px", overflowY: "auto" }}>
                                    {item.group_permissions.slice(3).map((group, idx) => (
                                        <div key={idx} style={{ marginBottom: 8 }}>
                                            {group}
                                        </div>
                                    ))}
                                </div>
                            }
                            title="More Permissions"
                            trigger="hover"
                            placement="left"
                        >
                            <Avatar style={{ backgroundColor: '#d9d9d9', color: '#000', cursor: 'pointer' }}>
                                +{item.group_permissions.length - 3}
                            </Avatar>
                        </Popover>
                    )}
                </Avatar.Group>
            ) : (
                'No permissions'
            )
        }] : [],
        ...hasPermission("can_view_group_permission_column_in_new_update") ? [{
            key: '6',
            field: 'Action',
            value: (
                <Button
                    type="link"
                    onClick={() => showPublishModal(item)}
                >
                    <EditOutlined />
                </Button>
            ),
        }] : [],
    ];

    return (
        <div>
            {loading ? (
                <Spin />
            ) : data && data.length > 0 ? (
                data.map((item, index) => (
                    <div key={index} style={{ marginBottom: 24 }}>
                        <Table
                            columns={columns}
                            dataSource={generateTableData(item)}
                            pagination={false}
                            showHeader={false}
                            size="small"
                            bordered
                        />
                    </div>
                ))
            ) : (
                <Empty description="No Data Available" />
            )}
        </div>
    );
};

const UpdateListTable = ({ data, loading, fetchDashboardUpdates }) => {
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const { hasPermission } = usePermissions();

    const [isPublishModalVisible, setIsPublishModalVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState({});
    const [buttonloading, setButtonLoading] = useState(false);

    const getFileIcon = (fileName) => {
        const extension = fileName?.split(".").pop().toLowerCase();

        switch (extension) {
            case "pdf":
              return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/PDF_file_icon.svg.png";
            case "doc":
            case "docx":
              return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/docx_icon.svg.png";
            case "jpg":
            case "jpeg":
              return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/jpeg-jpg.png";
            case "png":
              return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/png1.webp";
            case "zip":
              return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/zipppp.png";
            case "ppt":
            case "pptx":
              return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/images_1.png";
            default:
              return "https://locusbucket.s3.amazonaws.com/locustool/media/help_doc_file/file-file-type.svg";
          }
    };

    const showNewModal = (description, files) => {

        Modal.confirm({
            icon: null,
            title: (
                <Title level={4} style={{ margin: 0 }}>Description</Title>
            ),
            content: (
                <div
                    style={{
                        maxHeight: '60vh',
                        overflowY: 'auto',
                        paddingRight: '12px',
                        borderRadius: '6px',
                        marginBottom: "30px"
                    }}
                >
                    <div
                        dangerouslySetInnerHTML={{ __html: description }}
                    />
                    {files && files.length > 0 && <Divider orientation="center" style={{ marginBottom: "30px" }}>Uploaded Files</Divider>}
                    {files && files.length > 0 && (
                        <Row gutter={[16, 16]} style={{ marginBottom: "20px" }}>
                            {files?.map((item, index) => (
                                <Col xs={24} sm={8} key={index}>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            border: "1px solid #D3D3D3",
                                            padding: "10px",
                                            borderRadius: "10px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                height: "40px",
                                                width: "40px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            <img
                                                style={{ height: "50px", width: "50px" }}
                                                src={getFileIcon(item?.file_name)}
                                                alt="file-icon"
                                            />
                                        </div>
                                        <div style={{ flex: 1, marginLeft: "10px" }}>
                                            <div
                                                className="field-label"
                                                style={{ fontWeight: "normal", wordBreak: "break-all" }}
                                            >
                                                {item?.file_name
                                                    ? item?.file_name.length <= 13
                                                        ? item?.file_name
                                                        : `${item?.file_name.slice(0, 13)}.${item?.file_name.split(".").pop()}`
                                                    : "No file name"}
                                            </div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "start",
                                                    gap: "20px",
                                                    marginTop: "5px",
                                                    color: "gray",
                                                }}
                                            >
                                                <div>{(item?.file_size / 100).toFixed(2)} KB</div>
                                                <div>
                                                    <a
                                                        href={item?.file_url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <CloudDownloadOutlined style={{ fontSize: "19px", color: "gray" }} />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    )}
                </div>
            ),
            width: 800,
            okText: 'Close',
            footer: [
                <Button
                    key="close"
                    type="primary"
                    onClick={() => Modal.destroyAll()}
                    style={{
                        borderRadius: '6px',
                        backgroundColor: 'black',
                        borderColor: '#1677ff',
                        color: 'white',
                        position: 'absolute',
                        bottom: 16,
                        right: 16,
                        zIndex: 1000,
                    }}
                >
                    Close
                </Button>,
            ],
            maskClosable: true,
        });
    };

    const showPublishModal = (record) => {
        setSelectedRecord(record);
        setIsPublishModalVisible(true);
    };

    const handleConfirmToggle = async () => {
        setButtonLoading(true);
        try {
            const res = await axiosInstance.post(`/notifications/v2/update/toggle/published/${selectedRecord?.uid}/`);
            if (res.status === 200 && res.data.status === "success") {
                message.success(res.data.data)
                fetchDashboardUpdates();
                setIsPublishModalVisible(false);
            }
        } catch (error) {
            await catchError(error)
        } finally {
            setButtonLoading(false);
        }
    };

    const handleToggleCancel = () => {
        setIsPublishModalVisible(false);
    };

    const columns = [
        { title: 'Title', dataIndex: 'title', key: 'title' },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            render: (text, record) => (
                <div style={{ cursor: 'pointer', color: '#1677ff' }}
                    onClick={() => showNewModal(record.description, record.files)} >
                    View Description
                </div >
            ),
        },
        ...hasPermission("can_view_group_permission_column_in_new_update") ? [{
            title: 'Published',
            dataIndex: 'is_published',
            key: 'is_published',
            render: (val) =>
                val ? (
                    <CheckCircleOutlined style={{ color: 'green', fontSize: '18px' }} />
                ) : (
                    <CloseCircleOutlined style={{ color: 'red', fontSize: '18px' }} />
                ),
        }] : [],
        {
            title: 'Published On',
            dataIndex: 'published_on',
            key: 'published_on',
            render: (text) => moment(text).local().format("DD-MM-YYYY hh:mm A"),
        },
        ...hasPermission("can_view_group_permission_column_in_new_update") ? [{
            title: 'Group Permission',
            dataIndex: 'group_permissions',
            key: 'group_permissions',
            render: (groups) => {
                if (!Array.isArray(groups) || groups.length === 0) return 'No permissions';

                const visibleGroups = groups.slice(0, 3);
                const extraGroups = groups.slice(3);

                return (
                    <Avatar.Group>
                        {visibleGroups.map((group, idx) => (
                            <Tooltip key={idx} title={group}>
                                <Avatar style={{ backgroundColor: 'green', color: '#fff' }}>
                                    {group
                                        .split(' ')
                                        .map(w => w[0])
                                        .join('')
                                        .toUpperCase()}
                                </Avatar>
                            </Tooltip>
                        ))}

                        {extraGroups.length > 0 && (
                            <Popover
                                content={
                                    <div style={{ maxWidth: 200, maxHeight: "200px", overflowY: "scroll" }}>
                                        {extraGroups.map((group, index) => (
                                            <div key={index} style={{ marginBottom: 8 }}>
                                                {group}
                                            </div>
                                        ))}
                                    </div>
                                }
                                title="More Permissions"
                                trigger="hover"
                                placement="left"
                            >
                                <Avatar style={{ backgroundColor: '#d9d9d9', color: '#000', cursor: 'pointer' }}>
                                    +{extraGroups.length}
                                </Avatar>
                            </Popover>
                        )}
                    </Avatar.Group>
                );
            }
        }] : [],
        ...hasPermission("can_view_group_permission_column_in_new_update") ? [{
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <Button
                    type="link"
                    onClick={() => showPublishModal(record)}
                >
                    <EditOutlined />
                </Button>
            ),
        }] : []
    ]

    return (
        <>
            {loading ? (
                <Spin />
            ) : data && data.length > 0 ? (
                isMobile ? (
                    <MobileNewUpdates
                        data={data}
                        loading={loading}
                        onViewDescription={showNewModal}
                        showPublishModal={showPublishModal}
                    />
                ) : (
                    <Table
                        columns={columns}
                        dataSource={data}
                        pagination={{ pageSize: 10 }}
                        bordered
                        rowKey={(record) => record.id}
                    />
                )
            ) : (
                <Empty description="No Data Available" />
            )}

            <Modal
                maskClosable={false}
                className="custom-modal"
                title={
                    <div className="custom-modal-header">
                        <Title
                            style={{
                                color: "white",
                                marginLeft: "15px",
                                position: "relative",
                                fontSize: "clamp(14px, 3vw, 20px)",
                                top: "-5px",
                                padding: "0px",
                            }}>
                            {`${selectedRecord?.is_published ? 'Unpublish' : 'Publish'} Update`}
                        </Title>
                    </div>
                }
                footer={null}
                width={500}
                visible={isPublishModalVisible}
                onOk={handleConfirmToggle}
                onCancel={handleToggleCancel}
                okText="Yes"
                cancelText="Close"
                confirmLoading={buttonloading}
            >
                <p>Are you sure you want to <span style={{ fontWeight: 'bold' }}>{selectedRecord?.is_published ? 'Unpublish' : 'Publish'}</span> this Update?</p>
                <Flex justify="flex-end" align="flex-end" style={{ width: "100%" }}>
                    <Button
                        type="primary"
                        onClick={handleConfirmToggle}
                        loading={buttonloading}
                        style={{ background: "#001529", marginTop: 10 }}>
                        Submit
                    </Button>
                </Flex>
            </Modal>

        </>
    );
};

export default UpdateListTable;
